import { themeVariables } from "Components/theme";
import compact from "lodash/compact";
import filter from "lodash/filter";
import flatMap from "lodash/flatMap";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import { fromLonLat } from "ol/proj";
import { ZOOM } from "../constants";
export const geoCenterOfRussia = [104.5, 64.9];
export const rFontSmall = `normal normal normal ${themeVariables["font-size-small"]}/1 ${themeVariables["font-family-base"]}`;
export const initialOptions = {
    center: fromLonLat(geoCenterOfRussia),
    zoom: ZOOM.DEFAULT
};
export const clusterDistance = 20;
export const getCoordinatesPairs = (features) => filter(flatMap(features, "coordinates"), e => e && e.length === 2 && Number.isFinite(e[0]) && Number.isFinite(e[1]));
export const fitMapToPoints = (features, olMap) => {
    if (!olMap || isEmpty(features))
        return;
    const coordinatesPairs = getCoordinatesPairs(features);
    const x = map(coordinatesPairs, "[0]");
    const y = map(coordinatesPairs, "[1]");
    olMap.getView().fit([Math.min(...x), Math.min(...y), Math.max(...x), Math.max(...y)], {
        padding: [100, 100, 100, 100],
        maxZoom: 10,
        duration: 400,
        size: olMap.getSize()
    });
};
const getDataId = (feature) => { var _a; return (feature === null || feature === void 0 ? void 0 : feature.get("data")) ? (_a = feature.get("data")) === null || _a === void 0 ? void 0 : _a.id : undefined; };
export const getIds = (features) => compact(map(flatMap(features, f => {
    const id = getDataId(f);
    if (id)
        return [id];
    return map(f.get("features"), getDataId);
})));
const RADIUS = {
    MIN: 13,
    MAX: 18
};
export const MAX_CLUSTERED_FEATURES_DEFINED = 99;
export const getRadius = (size) => {
    if (size === 0)
        return 0;
    return Math.round(RADIUS.MIN + ((size - 2) * (RADIUS.MAX - RADIUS.MIN)) / (MAX_CLUSTERED_FEATURES_DEFINED - 2));
};
